import { createFileRoute } from '@tanstack/react-router';
import AvailabilityEdit from '~/containers/AvailabilityEdit';

export const Route = createFileRoute('/availability/$recurrentApplicationId')({
  component: AvailabilityEdit,
  validateSearch(search) {
    return {
      from: (search.from as string) || undefined,
      publisherId: (search.publisherId as string) || undefined,
    };
  },
});
